import React, { useState } from "react";
import styles from "./styles.module.scss";

function SkinnyJean() {
  const [selectedImage, setSelectedImage] = useState(
    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_1.webp"
  );
  const [glbContainer, setGlbContainer] = useState(false);
  const [mobileGlbcontainer, setMobileGlbcontainer] = useState(false);
  const [mobileimageContainer, setMobileimageContainer] = useState(true);
  const [imageContainer, setImageContainer] = useState(true);

  const toggleGlb = () => {
    setGlbContainer(true);
    setImageContainer(false);
  };

  const togglemobileGlb = () => {
    setMobileGlbcontainer(true);
    setMobileimageContainer(false);
  };

  const handleImageClick = (imageSrc) => {
    setGlbContainer(false);
    setMobileGlbcontainer(false);
    setSelectedImage(imageSrc);
    setImageContainer(true);
    setMobileimageContainer(true);
  };

  return (
    <div>
      <div className={styles.container}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/header.webp"
          alt=""
        />

        <div className={styles.mainSection}>
          <div className={styles.thumbnailSection}>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_1.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_1.webp"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_2.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_2.webp"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_3.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_3.webp"
                )
              }
            />

            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/360_thumbnail-3.webp
              "
              alt=""
              onClick={toggleGlb}
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_4.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_4.webp"
                )
              }
            />
          </div>
          <div className={styles.renderSection}>
            {imageContainer && <img src={selectedImage} alt="" />}
            {glbContainer && (
              <iframe
                title="desktopGlb"
                height={"692"}
                width={"495"}
                seamless
                src="https://www.pod.advflr.com/turnaround/perfect-jeans/skinny"
              ></iframe>
            )}
          </div>

          <div>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/cart.webp"
              alt=""
            />
          </div>
        </div>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/details.webp"
          alt=""
        />

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/footer.webp"
          alt=""
        />
      </div>

      <div className={styles.mobileContainer}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/mobile_header.webp"
          alt=""
        />

        <div className={styles.mainSection}>
          <div className={styles.renderSection}>
            {mobileimageContainer && <img src={selectedImage} alt="" />}
            {mobileGlbcontainer && (
              <iframe
                title="desktopGlb"
                width={"320"}
                height={"448"}
                seamless
                src="https://www.pod.advflr.com/turnaround/perfect-jeans/skinny"
              ></iframe>
            )}
          </div>
          <div className={styles.thumbnailSection}>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_1.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_1.webp"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_2.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_2.webp"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/360_thumbnail-3.webp
              "
              alt=""
              onClick={togglemobileGlb}
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_3.webp"
              alt=""
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/render_3.webp"
                )
              }
            />
          </div>
        </div>

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/mobile_cart.webp"
          alt=""
        />
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/mobile_details.webp"
          alt=""
        />
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/perfect-jeans/skinny/mobile_footer.webp"
          alt=""
        />
      </div>
    </div>
  );
}

export default SkinnyJean;
